import axios from "axios";
import { getQueryForGlobalCandidatesFilters } from "@/helpers/candidatesFunctions";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "/index.php";

const diagramGroupByValues = {
    filial: "filial",
    post: "post_code",
    citizenship: "citizenship",
    accountable: "accountable",
    invitedBy: "invited",
};

const state = () => ({
    reports: null,
});

const actions = {
    async fetchReports({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = getQueryForGlobalCandidatesFilters(filters);
        const url = addAuthKey(`${apiUrl}?r=api/candidate/diagram&${queryParams.join("&")}`, token);

        const { data } = await axios.get(url);

        commit("setReports", data);
    },
    async fetchSidesheetDiagram({ rootState }, payload) {
        const { chartName, groupByType, groupByValues, groupByValuesExcept, filters } = payload;

        const token = rootState.authToken;
        const queryParams = [
            `chart_name=${chartName}`,
            `group_by=${diagramGroupByValues[groupByType]}`,
            ...getQueryForGlobalCandidatesFilters(filters),
        ];

        if (groupByType === "invitedBy" && groupByValues && groupByValues.value) {
            queryParams.push(`invitedBy_id=${groupByValues.value}`);
        }

        if (groupByValues && groupByValues.length) {
            groupByValues.forEach(({ value }) => {
                queryParams.push(`${groupByType}[]=${value}`);
            });
            if (groupByValuesExcept) {
                queryParams.push(`excl${groupByType[0].toUpperCase() + groupByType.slice(1)}=1`);
            }
        }

        const url = addAuthKey(`${apiUrl}?r=api/candidate/diagram&${queryParams.join("&")}`, token);

        const { data } = await axios.get(url);

        return data;
    },
};

const mutations = {
    setReports(state, reports) {
        state.reports = reports;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
